import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import { NamedLink, LogoMedicoverSport, Badge } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import css from './TransactionItem.css';

const TransactionItem = ({
  state,
  createdAt = null,
  lastTransitionedAt = null,
  firstName = null,
  lastName = null,
  providerName = null,
  providerCountryId = null,
  listings = [],
  id = null,
  startDate,
  endDate,
  intl,
  processState,
  lineItems,
  partnership,
  stolen
}) => {
  const resolveState = () => {
    const now = moment();
    if (processState === 'accepted') {
      return now.diff(moment(startDate), 'days') > 0 ? intl.formatMessage({ id: "ConsoleTransactionPage.verifyDelayedRelease" }) : null;
    }
    if (processState === 'picked-up') {
      return now.diff(moment(endDate), 'days') > 0 ? intl.formatMessage({ id: "ConsoleTransactionPage.verifyDelayedReturn" }) : null;
    }
    return null;
  }

  const resolvedWarning = resolveState();

  const productsWithActualSeats = lineItems.reduce((accumulator, item) => {
    if (item?.code === 'day') {
      const { listingId, reversal, seats } = item;
      accumulator[listingId] = accumulator[listingId] ? accumulator[listingId] : 0;
      accumulator[listingId] += (reversal ? -1 : 1) * seats;
    }
    return accumulator;
  }, {});

  const listingsWithSeats = listings.map(listing => ({
    ...listing,
    seats: productsWithActualSeats[listing.id.uuid],
  }));

  const sortedListingsWithSeats = listingsWithSeats.sort((a, b) => b.seats - a.seats);
  const stateClassName = classNames({ [css.accepted]: processState === "accepted" });

  return (
    <li className={css.listItem} key={id}>
      <div className={css.transactionDetails}>
        <div className={css.firstTransactionDetails}>
          <div className={css.txHeader}>
            {firstName} {lastName}
            {
              stolen &&
              <Badge variant="stolen" className={css.marginLeft}>
                <FormattedMessage id="OrderDetails.stolenStatus" />
              </Badge>
            }
            {
              partnership &&
              <LogoMedicoverSport className={classNames(css.medicoverLogo)} />
            }
          </div>
          {sortedListingsWithSeats.map(({ id, attributes: { title }, seats }) => (
            <p className={classNames({ [css.lineThrough]: !seats })} key={id.uuid}>{seats}{' x '}{title}</p>
          ))}
          <p className={css.providerName}>
            {providerName} <em className={css.providerCountry}>({providerCountryId})</em>
          </p>
          <p>
            {intl.formatDate(startDate, {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })} - {intl.formatDate(endDate, { year: 'numeric', month: 'short', day: 'numeric' })}
          </p>
        </div>
        <div className={css.secondTransactionDetails}>
          <p className={stateClassName}>{state}</p>
          <p className={css.date}>
            <FormattedMessage id="Console.createdAt" />
            <span> {createdAt}</span>
          </p>
          <p className={css.date}>
            <FormattedMessage id="Console.lastTransitionedAt" />
            <span> {lastTransitionedAt}</span>
          </p>
          <div>
            {resolvedWarning &&
              <p className={css.warning}>
                {resolvedWarning}
              </p>
            }
          </div>
        </div>
      </div>
      <NamedLink className={css.link} name="SaleDetailsPage" params={{ id }}>
        <FormattedMessage id="Console.transactionDetails" />
      </NamedLink>
    </li>
  );
};

export default TransactionItem;
